import type { AppRouteModule } from '@/router/types';

import { LAYOUT } from '@/router/constant';
import { RoleEnum } from '@/enums/roleEnum';

const StoreManage: AppRouteModule = {
  path: '/storeManage',
  name: 'StoreManage',
  identify: 'storeManage',
  component: LAYOUT,
  redirect: '/storeManage/purchaseReturn',
  meta: {
    icon: 'heroicons-outline:library',
    title: '门店管理',
    roles: [RoleEnum.OFFLINE],
  },
  children: [
    // 采购退货
    {
      path: 'purchaseReturn',
      name: 'PurchaseReturn',
      component: () => import('@/views/storeManage/purchaseReturn/index.vue'),
      identify: 'purchaseReturn',
      meta: {
        title: '采购退货',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'purchaseReturn/:type/:order_num?',
      name: 'PurchaseReturnAdd',
      component: () => import('@/views/storeManage/purchaseReturn/add.vue'),
      identify: 'purchaseReturn',
      meta: {
        title: '采购退货详情',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/storeManage/purchaseReturn',
        roles: [RoleEnum.OFFLINE],
      },
    },
    // 采购换货
    {
      path: 'purchaseExchange',
      name: 'PurchaseExchange',
      component: () => import('@/views/storeManage/purchaseExchange/index.vue'),
      identify: 'purchaseExchange',
      meta: {
        title: '采购换货',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'purchaseExchange/:type/:order_num?',
      name: 'PurchaseExchangeAdd',
      component: () => import('@/views/storeManage/purchaseExchange/add.vue'),
      identify: 'purchaseExchange',
      meta: {
        title: '采购换货详情',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/storeManage/purchaseExchange',
        roles: [RoleEnum.OFFLINE],
      },
    },
  ],
};
export default StoreManage;
